import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import productsData from "../data/products.json";
import CompareProductDrawer from "./CompareProductDrawer"; // Import CompareProductDrawer
import seoFriendlySlug from "../utils/seoFriendlySlug";

const FeaturedProducts = () => {
  const isUAEPath = window.location.pathname.startsWith("/uae");
  const currentLocation = useLocation();

  const basePath = currentLocation.pathname.startsWith("/uae") ? "/uae" : "/";
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [compareProducts, setCompareProducts] = useState(
    JSON.parse(localStorage.getItem("compareProducts")) || [] // Load from localStorage
  );
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const featuredCategories = [
    "ENTRANCE CONTROL",
    "PARKING & TRAFFIC CONTROL",
    "INSPECTION CONTROL",
    "TIME ATTENDANCE & ACCESS CONTROL",
  ];

  const getProductsFromSingleCategory = () => {
    const filteredCategories = productsData.products.filter((category) =>
      featuredCategories.includes(category.categoryName)
    );

    if (filteredCategories.length === 0) {
      console.error("No categories match the predefined list.");
      return [];
    }

    const randomCategory =
      filteredCategories[Math.floor(Math.random() * filteredCategories.length)];

    const selectedProducts = [];

    randomCategory.subCategories.forEach((subCategory) => {
      subCategory.products.forEach((product) => {
        selectedProducts.push({
          ...product,
          categoryName: randomCategory.categoryName,
          subCategoryName: subCategory.subCategoryName,
        });
      });
    });

    return selectedProducts.sort(() => Math.random() - 0.5).slice(0, 4);
  };

  const handleCompareClick = (productName) => {
    setCompareProducts((prev) => {
      if (!prev.includes(productName)) {
        // Add the product only if the array has less than 3 items
        if (prev.length < 3) {
          const updatedList = [...prev, productName];
          localStorage.setItem("compareProducts", JSON.stringify(updatedList)); // Save to localStorage
          return updatedList;
        } else {
          alert("You can compare a maximum of 3 products."); // Optional: Provide user feedback
          return prev;
        }
      }
      return prev;
    });
  };

  const handleDeleteCompare = (productName) => {
    setCompareProducts((prev) => {
      const updatedList = prev.filter((item) => item !== productName);
      localStorage.setItem("compareProducts", JSON.stringify(updatedList)); // Save to localStorage
      return updatedList;
    });
  };

  useEffect(() => {
    const products = getProductsFromSingleCategory();
    setFeaturedProducts(products);
  }, []);

  return (
    <div className="container my-4 mt-5">
      <h2 className="text-center mb-4 fw-bold">Featured Products</h2>

      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
        {featuredProducts.map((product, index) => (
          <div className="col" key={index}>
            <div
              className="card h-100 d-flex flex-column position-relative"
              style={{
                background: "rgba(229, 229, 226, 0.4)",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
              }}
            >
              {/* Compare Icon with Hover Text */}
              {/* <div
                className="position-absolute top-0 end-0 m-2 d-flex align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => handleCompareClick(product.productName)}
              >
                <i
                  className="bi bi-bar-chart-line-fill text-success fs-4 me-1"
                  data-bs-toggle="tooltip"
                  title="Add to Compare"
                ></i>
                <span
                  className="compare-text bg-success text-white rounded px-2 py-1"
                  style={{ display: "none", whiteSpace: "nowrap" }}
                >
                  Add to Compare
                </span>
              </div> */}

              <Link
                onClick={scrollToTop}
                to={`${basePath}market-place/${seoFriendlySlug(product.categoryName)}/${seoFriendlySlug(
                  product.subCategoryName
                )}/${seoFriendlySlug(product.productName)}`}
                className="text-decoration-none"
              >
                <img
                  src={require(`../assets/products/${product.productimg}`)}
                  alt={product.productName}
                  width={"200"}
                  height={"200"}
                  className="card-img-top img-fluid"
                  style={{width: "200px"}}
                
                />
              </Link>
              <div className="card-body flex-grow-1">
                <h5 className="card-title fw-bold" style={{ color: "black" }}>
                  {product.productName}
                </h5>
              </div>
              <div className="mt-auto d-flex justify-content-between">
                <Link
                  style={{
                    textDecoration: "none",
                    backgroundColor: "#f14144",
                    color: "white",
                  }}
                  to={`${basePath}market-place/${seoFriendlySlug(product.categoryName)}/${seoFriendlySlug(product.subCategoryName)}/${seoFriendlySlug(product.productName)}`}
                  className="btn w-100 mb-2 fw-bold"
                  onClick={scrollToTop}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#F40004";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#f14144";
                  }}
                >
                  Details
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* <CompareProductDrawer
        compareProducts={compareProducts || []}
        setCompareProducts={setCompareProducts}
        handleDeleteCompare={handleDeleteCompare}
      /> */}
    </div>
  );
};

export default FeaturedProducts;
